import agreement from './agreement-template';
import channelDistribution from './channel-distribution-template';
import contractTemplate from './contract-template';
import digitalDistribution from './digital-distribution-template';
import merchDistribution from './merch-distribution-template';
import physicalDistribution from './physical-distribution-template';
import section from './section-template';

export default {
  section,
  agreement,
  contractTemplate,
  physicalDistribution,
  digitalDistribution,
  merchDistribution,
  channelDistribution,
};
